import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import lediumApi from '@client/utils/lediumApi';
import WbIncandescentIcon from '@mui/icons-material/WbIncandescent';
import { Button } from '@mui/material';

const DmxChannelTestButton = () => {
    const {
        pageState: { formData }
    } = usePageStore();
    let channelTestLock = false;

    function testChannel() {
        if (!channelTestLock) {
            channelTestLock = true;
            lediumApi.get(`lightChannels/testDmx/${formData.channel}/${formData.resolution}`).then(() => {
                channelTestLock = false;
            });
        }
    }

    if (!formData.channel) {
        return null;
    }
    return (
        <Button style={{ marginTop: '8px', marginLeft: '8px' }} variant="contained" onClick={testChannel} startIcon={<WbIncandescentIcon />}>
            {i18n('test_channel')}
        </Button>
    );
};

export default DmxChannelTestButton;
